import Vector from './../Support/Vector'

/**
 * Mouse class
 *      - keeps track of the current mouse position
 */
export default class {
    constructor (element) {
        this._el = element

        this._position = new Vector(0, 0)
        this._el.onmousemove = (event) => this._updatePosition(event)
    }

    getPosition () {
        return this._position.clone()
    }

    _updatePosition (event) {
        this._position.setX(event.clientX).setY(event.clientY)
    }
}
